export const IconAdd = ({ className }: { className?: string }) => (
  <svg className={className} focusable="false" aria-hidden="true" viewBox="0 0 24 24" tabIndex={-1}>
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"></path>
  </svg>
);
